import { SettingProfile } from "features/Setting"

export const SettingProfilePages = () => {
    return (
        <SettingProfile />
    )
}